import PropTypes from 'prop-types';
import ReactHtmlParser from 'html-react-parser';
import { staticData } from './../../../static/json-place-holder';
import * as React from 'react';

const Footer = () => {
  const { footer } = staticData;
  return (
    <footer>
      <div className="container">
        <div className="footer-links">
          <div className="row">
            <div className="col-md-12">
              <div id="footer-logo-svg">
                <svg
                  className="logo"
                  width="55"
                  height="55"
                  aria-labelledby="HomeServe-Logo"
                  focusable="false"
                  data-name="Loading Wording"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 55 55"
                >
                  <title id="HomeServe-Logo">Logo</title>
                  <path
                    className="house"
                    d="M52.76,26c-2.87-2.87-23-22.31-23-22.31a2.89,2.89,0,0,0-4.08,0L17,12.1V10.89A2.89,2.89,0,0,0,14.11,8H10.89A2.89,2.89,0,0,0,8,10.89V21L2.78,26.1a2.86,2.86,0,0,0-.84,2.22A3,3,0,0,0,5,31H8V50.11A2.89,2.89,0,0,0,10.9,53H45.1A2.88,2.88,0,0,0,48,50.15L48,31h3.29a2.72,2.72,0,0,0,2.89-2.89C54.2,27,53.21,26.44,52.76,26Z"
                  />
                  <path
                    className="smile"
                    d="M43.93,39.73a20.4,20.4,0,0,1-15.86,7.33A20.39,20.39,0,0,1,12.19,39.7a1.7,1.7,0,1,1,2.66-2.12,16.92,16.92,0,0,0,13.22,6.08,16.92,16.92,0,0,0,13.2-6.05,1.7,1.7,0,1,1,2.66,2.13"
                  />
                </svg>
                {footer?.footerLinks.map(point => (
                  <span className="inline-links" key={point.id}>
                    <a href={point.url} role="link" target="_blank" aria-label={`View ${point.footerText} in new tab`}>
                      {point.footerText}
                    </a>
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="red-line" />
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-sm-pull-6">
            <div className="footer-base-content left">
              {`© HomeServe Membership Limited ${new Date().getFullYear()}.`}
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid footer-baseline">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              {ReactHtmlParser(footer?.footerLegalText)}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
Footer.propTypes = {
  data: PropTypes.object,
  page: PropTypes.string,
};
